import styled from 'styled-components'
import { SIZES } from '../../../constants'

export default styled.span`
  display: block;
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;
  margin-left: 15px;
  @media (min-width: ${SIZES.BREAKPOINT_XS}px) {
    display: none;
  }
`
